// ============================================================================
// RecordManagementPage.js
//
// "Record Management" tab — a thin wrapper around StudentListBase locked to
// mode="manage" so that View, Edit, Promote, and Delete are all available on
// this single page.
//
// Individual action buttons are still gated by canEdit / canDelete /
// canWithdraw so each role only sees the actions it is permitted to perform.
//
// Props forwarded to StudentListBase:
//   • students             — array of student objects from the parent
//   • onDeleteClick        — (unused in manage mode; inline modal is used)
//   • onEditClick          — fallback if onSaveEdit is not provided
//   • onDeleteFiltered     — bulk-delete handler
//   • onWithdrawStudent    — withdrawal handler
//   • onPromoteStudent     — single-student promote handler
//   • onPromoteFiltered    — bulk-promote handler
//   • onSaveEdit           — async (formData) => bool — saves an inline edit
//   • userRole             — current user's role string
//   • onLogout             — logout callback
//   • showToast            — (type, title, message) toast notification
//   • canEdit              — whether the user may edit records
//   • canDelete            — whether the user may delete records
//   • canWithdraw          — whether the user may withdraw students
// ============================================================================

import React from "react";
import StudentListBase from "./StudentListBase";

function RecordManagementPage(props) {
  return <StudentListBase {...props} mode="manage" />;
}

export default RecordManagementPage;
